export default "__VITE_ASSET__PLhOfywo__"